/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ArrowLeft } from "lucide-react";
import { Loading } from "../../components/Loading/Loading";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import ContextConstructor from "../../components/Context/ContextProvider";
import { handleChannelBack } from "../../utils/handleChannelBack";
import BenefitsContact from "./BenefitsContact";
import AssociateCards from "./AssociateCards";
import qrcode_icon from "../../images/qrcode_icon.svg"
import QRCodeCard from "./QRCodeCard";
import repsolLogo from "../../images/repsol_logo.svg"
import alert_close from "../../images/alert_lose.svg"
import { fetchJson } from "../../utils/authenticatedFetch";

/* MODULE IMPORTS */
import React, { Component } from "react";
import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import "./CartaoAssociado.css";

var reactPlugin = new ReactPlugin();

export class CartaoAssociado extends Component {
  static displayName = CartaoAssociado.name;

  constructor(props) {
    super(props);
    this.state = {
      error: [],
      profile: [],
      loading: true,
      qrcodeOpened: false
    };
  }

  async componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.getData();
    }
  }

  renderCard(profile) {
    return (
      <main className="main-associate">
        <div className="title-bar title-bar-mail associate-header">
          <div className="title">
            <ArrowLeft
              className="profile-title-back"
              onClick={() => {
                this.handleBack();
              }}
            />
            Cartão de Associado
          </div>
          <div>
            <button className="qrcode_button" onClick={() => {
              this.openQRCodeAlertRepsol()
            }}>
              <h4>QR Code Repsol </h4>
              <img src={qrcode_icon} alt="qr code icon" />
            </button>
          </div>
        </div>
        {this.state.qrcodeOpened &&
          (<div className="modal-overlay-associate">
            <div className="alert-modal-wrapper-associate">
              <button
                type="button"
                className="alert-modal-close-associate"
                onClick={() => this.openQRCodeAlertRepsol()}
                aria-label="Fechar modal"
              >
                <img src={alert_close} alt="Fechar modal" />
              </button>
              <div className="alert-modal-associate">
                <QRCodeCard
                  qrValue={profile.repsol_Card}
                  title="MONTEPIO ASSOCIAÇÃO MUTUALISTA"
                  subtitle={profile.repsol_Card}
                  logo={repsolLogo}
                  logoAlt="Repsol"
                  qrSize={152}
                  onClick={() => this.openQRCodeAlertRepsol()}
                />
              </div>
            </div>
          </div>)
        }
        <div className="Card_Modalidades">
          <AssociateCards
            userName={profile.name}
            membershipNumber={profile.associateID} />
          <BenefitsContact />
        </div>
      </main>
    );
  }

  handleBack = () => {
    handleChannelBack({
      isMobileAuth: this.context.isMobileAuth,
      onWebBack: () => this.props.history.goBack(),
    });
  };

  openQRCodeAlertRepsol = () => {
    this.setState({ qrcodeOpened: !this.state.qrcodeOpened })
  }

  render() {
    let contents = this.state.loading ? (
      <Loading />
    ) : this.state.error ? (
      <ErrorPage />
    ) : (
      this.renderCard(this.state.profile)
    );
    return <React.Fragment>{contents}</React.Fragment>;
  }

  async getData() {
    try {
      const { selectedUserID } = this.context;

      const headers = {
        clientId: selectedUserID,
      };

      const userProfileResponse = await fetchJson("/Profile/GetProfile", { headers });

      this.setState({
        profile: userProfileResponse,
        error: false,
        loading: false,
      });
    } catch (error) {
      console.error("Error in getData:", error);

      this.setState({
        error: true,
        loading: false,
      });

      sendLogError(error.message, "getData");
    }
  }
}

CartaoAssociado.contextType = ContextConstructor;

export default withAITracking(reactPlugin, CartaoAssociado);
